/** Prix unitaire achat affiché depuis la fiche ERP (table products). */

export function parseErpProductPriceField(raw: unknown): number | null {
    if (raw === undefined || raw === null || raw === '') {
        return null;
    }
    const n = typeof raw === 'number' ? raw : parseFloat(String(raw).replace(',', '.'));
    return Number.isFinite(n) ? n : null;
}

/**
 * `prix_unitaires` si renseigné en base ; sinon `achat_ht` (puis repli `prix_achat`).
 */
export function resolveErpProductPrixUnitaireAchat(product: any): number {
    const p = product?.data ?? product;
    if (!p || typeof p !== 'object') {
        return 0;
    }
    if (p.prix_unitaires !== undefined && p.prix_unitaires !== null && p.prix_unitaires !== '') {
        const pu = parseErpProductPriceField(p.prix_unitaires);
        if (pu != null) {
            return pu;
        }
    }
    const achat = parseErpProductPriceField(p.achat_ht ?? p.prix_achat);
    return achat ?? 0;
}

/** CMUP / valorisation stock — `products.valeur_unitaire`. */
export function resolveErpProductValeurUnitaire(product: any): number {
    const p = product?.data ?? product;
    if (!p || typeof p !== 'object') {
        return 0;
    }
    const vu = parseErpProductPriceField(p.valeur_unitaire);
    return vu != null && vu >= 0 ? vu : 0;
}

/** `valeur_unitaire` sur la ligne ou le produit ERP imbriqué. */
export function resolveErpValeurUnitaireFromLigne(ligne: any): number {
    if (!ligne || typeof ligne !== 'object') {
        return 0;
    }
    const fromLine = parseErpProductPriceField(ligne.valeur_unitaire);
    if (fromLine != null && fromLine > 0) {
        return fromLine;
    }
    const embedded =
        ligne.produit ?? ligne.product ?? ligne.product_data ?? ligne.produit_data ?? null;
    if (embedded && typeof embedded === 'object') {
        const fromProduct = resolveErpProductValeurUnitaire(embedded);
        if (fromProduct > 0) {
            return fromProduct;
        }
    }
    return 0;
}

/** Prix catalogue sur une ligne déjà enrichie produit ERP. */
export function resolveErpPrixUnitaireFromLigne(ligne: any): number {
    if (!ligne || typeof ligne !== 'object') {
        return 0;
    }
    if (ligne.prix_unitaires !== undefined && ligne.prix_unitaires !== null && ligne.prix_unitaires !== '') {
        const pu = parseErpProductPriceField(ligne.prix_unitaires);
        if (pu != null) {
            return pu;
        }
    }
    if (ligne.achat_ht !== undefined && ligne.achat_ht !== null && ligne.achat_ht !== '') {
        const a = parseErpProductPriceField(ligne.achat_ht);
        if (a != null) {
            return a;
        }
    }
    return 0;
}
